import React from 'react'
import { Button, Modal } from 'antd'

import StatusCell from '../StatusCell'
import { LOCKBOX_STATUS_OPTIONS } from '../utils'

const LOCKBOX_FIELDS = [
  {
    label: 'Property',
    renderValue: lockbox => lockbox?.property?.internalListingName || '--'
  },
  {
    label: 'Unit',
    renderValue: lockbox => {
      if (!lockbox?.UnitID) {
        return '--'
      }

      const unit = lockbox.property.listingUnits.find(unit => {
        return unit.id === Number(lockbox.UnitID)
      })

      return unit.name
    }
  },
  {
    label: 'Lockbox Name',
    renderValue: lockbox => lockbox?.LockBoxName || '--'
  },
  {
    label: 'Code',
    renderValue: lockbox => lockbox?.Code || '--'
  },
  {
    label: 'Lockbox Type',
    renderValue: lockbox => {
      return lockbox?.LockboxType || '--'
    }
  },
  {
    label: 'Status', 
    renderValue: (lockbox, canUpdate, refetch, onClose) => {
      if (!lockbox?.status) {
        return '--'
      }

      return (
        <StatusCell
          disabled={!canUpdate}
          onSuccess={onClose}
          refetch={refetch}
          name={lockbox?.LockBoxName}
          typeName="lockBox"
          requestKey="updateLockBoxStatus"
          statusOptions={LOCKBOX_STATUS_OPTIONS}
          status={lockbox.status}
          _id={lockbox._id}
        />
      )
    }
  }
]

function LockBoxDetailsModal (props) {
  const {
    canDelete,
    canUpdate,
    handleDeleteModalOpen,
    lockBox,
    onClose,
    open,
    triggerLockBoxCollectionRefetch
  } = props

  return (
    <Modal
      title='Lockbox details'
      open={open}
      footer={null}
      onCancel={onClose}
    >
      <div className="grid sm:grid-cols-2 gap-2 pt-2">
        {LOCKBOX_FIELDS.map(({ label, renderValue }) => (
          <div key={label}>
            <div className="font-semibold">
              {label}
            </div>

            <div>
              {renderValue(lockBox, canUpdate, triggerLockBoxCollectionRefetch, onClose)}
            </div>
          </div>
        ))}
      </div>

      <div className="flex items-center justify-end gap-2 pt-10">
        {canDelete && (
          <Button
            onClick={handleDeleteModalOpen}
            className="mr-auto"
            type="primary"
            danger
          >
            Delete lockbox
          </Button>
        )}

        <Button
          className="hover:!text-black hover:!border-labelGrey"
          onClick={onClose}
        >
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default LockBoxDetailsModal
